import React, { useReducer } from 'react';
import ApplicationContext from './applicationContext';
import applicationReducer from './applicationReducer';

import clienteAxios from '../../service/axios';

import { 
    OBTENER_APPLICATIONS,
    OBTENER_APPLICATION,
    OBTENER_INTEGRATIONS,
    MARCA_ERROR,
    MARCA_OK
} from 'types/context';

const ApplicationState = props => {
    const initialState = {
        applications : [], 
        integrations:[],
        application: null,
        cliente: null,
        formulario : false,
        errorformulario: false,        
        mensaje: null
    }

    const [ state, dispatch ] = useReducer(applicationReducer, initialState);
    const obtenerApplications = async () => {
        try {
            // siempre deberia venir un cliente
            let resultado;            
                resultado = await clienteAxios.get(`/applications`);            
            //console.log("context =>",resultado);
                
                //console.log("tempArr =>",tempArr)
            dispatch({
                type: OBTENER_APPLICATIONS,
                payload: resultado.data?resultado.data.result:resultado
            });
            return resultado.data?resultado.data.result:resultado          
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }            
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
            return(error)
        }
    }
    const obtenerApplication = async (applicationId) => {
        try {
            // siempre deberia venir un cliente
            let resultado;            
                resultado = await clienteAxios.get(`/applications?id=${applicationId}`);            
            
            dispatch({
                type: OBTENER_APPLICATION,
                payload: resultado.data
            });
            return resultado.data    
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }            
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
            return(error)
        }
    }
    const obtenerIntegrations = async (applicationID, filter) => {
        try {
            // siempre deberia venir un cliente
            let resultado;            
                resultado = await clienteAxios.get(`/applications/${applicationID}/integrations${filter?"/"+filter:""}`);            
            console.log("context =>",resultado);
                
                //console.log("tempArr =>",tempArr)
            dispatch({
                type: OBTENER_INTEGRATIONS,
                payload: resultado.data?resultado.data.integration?[resultado.data.integration]:[]:resultado
            });
            return resultado.data?resultado.data.integration?[resultado.data.integration]:[]:resultado          
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }    /*        
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })*/
            return(error)
        }
    }
    const agregarApplication = async(newApplication) => {
        try {
            const resultado = await clienteAxios.post('/applications',newApplication);         
            const alerta = {
                msg: "application agregado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: MARCA_OK,
                payload: alerta
            })
            return resultado.status
        } catch (error) {
            const alerta = {
                msg: error,
                categoria: 'error'
            }
            
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
            return alerta
        }
    }

    const eliminarApplication = async (applicationId) => {
        try {
            await clienteAxios.delete(`/applications/${applicationId}`);
            /* dispatch({
                type: ELIMINAR_MARCA,
                payload: marcaId
            }) */
            const alerta = {
                msg: "application eliminada con exito",
                categoria: 'exito'
            }
            dispatch({
                type: MARCA_OK,
                payload: alerta
            })
        } catch (error) {
            const alerta = {
                msg: error,
                categoria: 'error'
            }
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
        }
    }
    const actualizarApplication = async(application) => {
        try {
            const resultado = await clienteAxios.put(`/applications/${application.id}`,application);            
            const alerta = {
                msg: "application modificada con exito",
                categoria: 'exito'
            }
            dispatch({
                type: MARCA_OK,
                payload: alerta
            })
            return resultado.status
        }catch (error){
            const alerta = {
                msg: error,
                categoria: 'error'
            }            
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
        }
    }

    const agregarIntegration = async(integration) => {
       
        try {
            let id = integration.applicationId
            const resultado = await clienteAxios.post(`/applications/${id}/integrations/http`,integration);            
            const alerta = {
                msg: "integracion creada con exito",
                categoria: 'exito'
            }
            dispatch({
                type: MARCA_OK,
                payload: alerta
            })
            return resultado.status
        } catch (error) {
            const alerta = {
                msg: error,
                categoria: 'error'
            }
            
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
            return alerta
        }
    }
    const eliminarIntegrationHttp = async(id) => {       
        try {
            const resultado = await clienteAxios.delete(`/applications/${id}/integrations/http`);            
            const alerta = {
                msg: "integracion eliminada con exito",
                categoria: 'exito'
            }
            dispatch({
                type: MARCA_OK,
                payload: alerta
            })
            return resultado.status
        } catch (error) {
            const alerta = {
                msg: error,
                categoria: 'error'
            }
            
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
            return alerta
        }
    }
    
    const editarIntegrationHttp = async(application,integration) => {
        try {
            const resultado = await clienteAxios.put(`/applications/${application.applicationID}/integrations/http`,
            {"integration":integration}
            );            
            const alerta = {
                msg: "integracion HTTP modificada con exito",
                categoria: 'exito'
            }
            dispatch({
                type: MARCA_OK,
                payload: alerta
            })
            return resultado.status
        }catch (error){
            const alerta = {
                msg: error,
                categoria: 'error'
            }            
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
        }
    }
    // muestra un error de validacion
    const errorMarca = (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }            
        dispatch({
            type: MARCA_ERROR,
            payload: alerta
        })
    }
    const OkMarca = (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }            
        dispatch({
            type: MARCA_OK,
            payload: alerta
        })
    }
    const clearErrorMarca = () => {
        dispatch({
            type: MARCA_ERROR,
            payload: null,
        });
        };

    const clearOkMarca = () => {
        dispatch({
            type: MARCA_OK,
            payload: null,
        });
    };

    
    return(
        <ApplicationContext.Provider
            value={{
                applications: state.applications,
                application: state.application,
                integrations: state.integrations,
                cliente: state.cliente,
                formulario: state.formulario,
                errorformulario: state.errorformulario,                
                mensaje: state.mensaje,
                agregarIntegration,
                obtenerApplications,
                obtenerApplication, 
                obtenerIntegrations,
                agregarApplication,
                eliminarApplication,
                eliminarIntegrationHttp,
                editarIntegrationHttp,
                actualizarApplication,              
                clearErrorMarca,
                clearOkMarca,
                errorMarca,
                OkMarca,
            }}
        >{props.children}

        </ApplicationContext.Provider>
    )
}
export default ApplicationState;
